import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { APIGetResponse } from './types';
import { axiosBaseQuery } from './baseQuery';
import { AxiosResponse } from 'axios';

const PRODUCT_THEME_URL = `/api/product-themes`;

export const productThemeApi = createApi({
  reducerPath: 'productTheme.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['productTheme'],
  endpoints: (builder) => ({
    getProductThemes: builder.query({
      query: ({ pageNo = 0, pageSize = DEFAULT_ROWS_PER_PAGE, name = '', status = '' }) => ({
        url: `${PRODUCT_THEME_URL}?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}&status=${status}`,
      }),
      transformResponse: (response: any, meta: any) => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        };
      },
      providesTags: ['productTheme'],
    }),
    getProductThemeById: builder.query({
      query: (id) => ({ url: `${PRODUCT_THEME_URL}/${id}` }),
      providesTags: ['productTheme'],
    }),
    addProductTheme: builder.mutation({
      query: (body) => ({
        url: `${PRODUCT_THEME_URL}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['productTheme'],
    }),
    deleteProductTheme: builder.mutation({
      query: (id) => ({
        url: `${PRODUCT_THEME_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['productTheme'],
    }),
    updateProductTheme: builder.mutation({
      query: (data) => ({
        url: `${PRODUCT_THEME_URL}/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['productTheme'],
    }),
    updateProductThemePosition: builder.mutation({
      query: (data) => ({
        url: `${PRODUCT_THEME_URL}/position`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['productTheme'],
    }),
  }),
});

export const {
  useGetProductThemesQuery,
  useGetProductThemeByIdQuery,
  useAddProductThemeMutation,
  useDeleteProductThemeMutation,
  useUpdateProductThemeMutation,
  useUpdateProductThemePositionMutation,
} = productThemeApi;
